import * as React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Chip from '@mui/material/Chip';

export default function RecentLoginActivityGrid({
    activityData,
    isAdmin,
    errorOccured,
}) {
    const getInitials = (username) => {
        return username ? username.charAt(0).toUpperCase() : '?';
    };

    const formatTimeAgo = (dateString) => {
        const diffInMinutes = Math.floor(
            (new Date() - new Date(dateString)) / 60000
        );

        if (diffInMinutes < 60) return `${diffInMinutes}m ago`;

        const diffInHours = Math.floor(diffInMinutes / 60);
        if (diffInHours < 24) return `${diffInHours}h ago`;

        const diffInDays = Math.floor(diffInHours / 24);
        return `${diffInDays}d ago`;
    };

    return (
        <Grid item xs={12} md={3}>
            <Card variant="outlined" sx={{ height: 400 }}>
                <CardContent>
                    <Typography variant="h6" gutterBottom>
                        {isAdmin ? 'Recent Login Activity' : 'My Activity'}
                    </Typography>

                    {errorOccured ? (
                        <Typography color="error" variant="body2">
                            {errorOccured}
                        </Typography>
                    ) : activityData.recentLogins.length === 0 ? (
                        <Typography color="text.secondary" variant="body2">
                            No recent activity
                        </Typography>
                    ) : (
                        <List dense>
                            {activityData.recentLogins
                                .slice(0, 8)
                                .map((activity, index) => (
                                    <ListItem
                                        key={activity.id || index}
                                        divider={
                                            index <
                                            activityData.recentLogins.length - 1
                                        }
                                    >
                                        <ListItemAvatar>
                                            <Avatar
                                                sx={{
                                                    width: 32,
                                                    height: 32,
                                                    fontSize: '0.875rem',
                                                }}
                                            >
                                                {getInitials(activity.username)}
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText
                                            primary={
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: 1,
                                                    }}
                                                >
                                                    <Typography
                                                        variant="body2"
                                                        fontWeight="medium"
                                                    >
                                                        {activity.username}
                                                    </Typography>
                                                    <Chip
                                                        label="logged in"
                                                        size="small"
                                                        color="success"
                                                        variant="outlined"
                                                    />
                                                </Box>
                                            }
                                            secondary={
                                                <Box>
                                                    <Typography
                                                        variant="caption"
                                                        color="text.secondary"
                                                    >
                                                        {formatTimeAgo(
                                                            activity.timestamp
                                                        )}
                                                    </Typography>
                                                    {activity.ip_address && (
                                                        <Typography
                                                            variant="caption"
                                                            color="text.secondary"
                                                            sx={{ ml: 1 }}
                                                        >
                                                            •{' '}
                                                            {
                                                                activity.ip_address
                                                            }
                                                        </Typography>
                                                    )}
                                                </Box>
                                            }
                                        />
                                    </ListItem>
                                ))}
                        </List>
                    )}
                </CardContent>
            </Card>
        </Grid>
    );
}
